export const ParterSpotlightIcon = (props) => {
  // const { className } = props;

  return <h5 style={{ marginBottom: 0 }}>P</h5>;
};
